enum OrdersDataType {
  GET_ORDERS_DATA_REQUEST = 'orders/getOrdersDataRequest',
  GET_ORDERS_DATA_REJECTED = 'orders/getOrdersDataRejected',
  GET_ORDERS_DATA_FULFILLED = 'orders/getOrdersDataFulfilled',
}

export default OrdersDataType;
